module.exports = __webpack_public_path__ + "img/logo3.24ec5c02.svg";